export enum CommentType {
    Comment,
    Reply,
    Edited,
    Automated,
    ApprovalLetter
}